import { EventFactory } from "applesauce-core/factories";
import { NostrEvent } from "applesauce-core/helpers";

import { WIFI_NETWORK_KIND } from "../const";
import {
  GeohashLatLng,
  includeGeohashTags,
  includeWifiTags,
  WifiNetworkData,
} from "../operations/event/wifi";

export class WifiNetworkFactory extends EventFactory<typeof WIFI_NETWORK_KIND> {
  static create(
    wifi: WifiNetworkData,
    location: string | GeohashLatLng,
    description?: string,
  ) {
    const factory = EventFactory.fromKind(WIFI_NETWORK_KIND)
      .modifyPublicTags(includeWifiTags(wifi), includeGeohashTags(location))
      .content(description ?? "");

    return factory as WifiNetworkFactory;
  }

  static modify(event: NostrEvent) {
    return EventFactory.fromEvent(event) as WifiNetworkFactory;
  }

  setWifi(wifi: WifiNetworkData) {
    return this.modifyPublicTags(includeWifiTags(wifi));
  }

  setLocation(location: string | GeohashLatLng) {
    return this.modifyPublicTags(includeGeohashTags(location));
  }
}
